import { createAction, createAsyncAction } from 'typesafe-actions';
import { BasketItem, BasketItemFlow, MeasurementSettings } from '../types';

/**
 * Do not use `BASKET_` actions outside of `feature` dir.
 * Use BasketFlowActions with GA handler included
 */
export const BASKET_UPDATE_ITEM = createAction('basket/BASKET_UPDATE_ITEM')<BasketItem>();
export const BASKET_SET = createAction('basket/BASKET_SET')<BasketItem[]>();

export const FETCH_MEASUREMENT_SETTINGS = createAsyncAction(
  'basket/FETCH_MEASUREMENT_SETTINGS/request',
  'basket/FETCH_MEASUREMENT_SETTINGS/success',
  'basket/FETCH_MEASUREMENT_SETTINGS/failure',
  'basket/FETCH_MEASUREMENT_SETTINGS/cancel',
)<void, MeasurementSettings | null, Error, void>();

const PREFIX = 'basket/flow';

export type BasketFlowUpdateItemPayload = BasketItemFlow & { isNeedGA?: boolean };
export const BASKET_FLOW_UPDATE_ITEM = createAction(`${PREFIX}/UPDATE_ITEM`)<BasketFlowUpdateItemPayload>();

export type BasketFlowResetItemPayload = Omit<BasketItemFlow, 'flowQty'>;
export const BASKET_FLOW_RESET_ITEM = createAction(`${PREFIX}/RESET_ITEM`)<BasketFlowResetItemPayload>();

export type BasketUpdatePayload = BasketItem[];
export const BASKET_FLOW_LOAD = createAction(`${PREFIX}/LOAD`)();
export const BASKET_FLOW_UPDATE = createAction(`${PREFIX}/UPDATE`)<BasketUpdatePayload>();

export type UpdateTintServiceInBasketPayload = {
  parentLineId: string;
  flowQty: number;
  hex: string;
  color: string;
  serviceIdForTint: string;
  currentServiceQuantity: number;
};

export const UPDATE_TINT_SERVICE_IN_SERVICE_BASKET = createAction(
  'service_basket/UPDATE_TINT_SERVICE_IN_SERVICE_BASKET',
)<UpdateTintServiceInBasketPayload>();
